import { Goal, ID } from '@griply/types';

export const findGoalById = (
  goals: Goal[],
  id?: ID | null,
): Goal | undefined => {
  if (!id) {
    return undefined;
  }
  return goals.find((goal) => goal.id === id);
};
